import Backbone from 'backbone'
import template from './box-options.hbs'
import _ from 'lodash'
import $ from 'jquery'

var BoxOptions = Backbone.View.extend({

	tagName: 'ul',

	className: 'box-options',

	events: {
		'click li': 'onClickOption'
	},

	/**
	 * @param  {Array} options.availableOptions an array of options to display in the control.
	 * Each option must include a unique `value` property and can optionally include
	 * `title` and `icon` and `isDisabled` properties.
	 */
	initialize: function(options) {
		this.options = options
	},

	render: function() {
		let templateToUse = this.options.template || template
		this.$el.html(templateToUse({ options: this.options.availableOptions }))
		if (this.options.layout) {
			this.$el.addClass(`layout-${this.options.layout}`)
		}
		return this
	},

	onClickOption: function(e) {
		let newVal = $(e.currentTarget).data('value')
		this.select(newVal)
	},

	/**
	 * Selects a new option. Called both when an option is clicked and when
	 * an option is chosen programmatically
	 */
	select(newVal) {
		let option = this._getOption(newVal)
		let optionEl = this._getOptionEl(option)
		let disabled = optionEl.hasClass('is-disabled')

		if (disabled) {
			this.trigger('select:disabled', { option, optionEl })
		} else {
			this.$('li').each(function () {
				$(this).toggleClass('is-selected', $(this).data('value') == newVal)
			})

			let oldOption = this._getOption(this._oldVal)
			this.trigger('select', option, oldOption)
		}

		this._oldVal = newVal
	},

	val: function (newVal) {
		if (_.isNil(newVal)) {
			return this.$('li.is-selected').data('value')
		}

		this.select(newVal)
	},

	toggleEnabled: function (option, enable) {
		if (enable) {
			this.enable(option)
		} else {
			this.disable(option)
		}
	},

	enable: function(option) {
		this._getOptionEl(option).removeClass('is-disabled')
	},

	disable: function(option) {
		this._getOptionEl(option)
			.removeClass('is-selected')
			.addClass('is-disabled')
	},

	removeOption: function(option) {
		this._getOptionEl(option).remove()
		_.remove(this.options.availableOptions, o => o.value == option.value)
	},

	_getOption: function(val) {
		return _.find(this.options.availableOptions, opt => opt.value == val)
	},

	_getOptionEl: function(option) {
		// Find and return the corresponding li element based on a given option
		var index = _.findIndex(this.options.availableOptions, o => {
			return o.value == option.value
		})
		return this.$(`li:nth-child(${index + 1})`)
	}
})

export default BoxOptions

BoxOptions.__filename__ = 'components/box-options.js'
